import { render, staticRenderFns } from "./linphone.vue?vue&type=template&id=f79992c2&scoped=true"
import script from "./linphone.vue?vue&type=script&lang=js"
export * from "./linphone.vue?vue&type=script&lang=js"
import style0 from "./linphone.vue?vue&type=style&index=0&id=f79992c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79992c2",
  null
  
)

export default component.exports